export default {
  getIncidents(state) {
    return state;
  } 
}
